<script setup lang="ts">
import { useAttrs } from "vue";

import { useClientTimezone } from "@/composables/utils/timezone/use-client-timezone";
import { TSite } from "@/data/api/kili/sites/types/sites.type";
import { useTypedIntl } from "@/locales/typed-intl";

import Message from "primevue/message";

const { t, k } = useTypedIntl();

interface IProps {
  site?: TSite;
}

const props = defineProps<IProps>();
const clientTimezone = useClientTimezone();
const attrs = useAttrs();
</script>

<template>
  <template v-if="props.site?.siteAddressDto?.geolocatedSiteAddress?.timeZone">
    <Message
      v-if="props.site?.siteAddressDto.geolocatedSiteAddress.timeZone === clientTimezone"
      v-bind="attrs"
      icon="pi pi-info-circle"
      severity="info"
    >
      <p>
        {{
          t(
            k.wizard.piloting.timezone.siteTimezoneInfo({
              timezone: props.site.siteAddressDto.geolocatedSiteAddress.timeZone,
            }),
          )
        }}
      </p>
    </Message>
    <Message
      v-else
      v-bind="attrs"
      icon="pi pi-exclamation-triangle"
      :pt="{
        content: {
          class: '!items-start !justify-start bg-surface-warning',
        },
        icon: {
          class: 'translate-y-1',
        },
      }"
      severity="warn"
    >
      <p>
        {{
          t(
            k.wizard.piloting.timezone.siteTimezoneWarning({
              clientTimezone: clientTimezone,
              siteTimezone: props.site.siteAddressDto.geolocatedSiteAddress.timeZone,
            }),
          )
        }}
      </p>
      <p>
        {{
          t(
            k.wizard.piloting.timezone.siteTimezoneInfo({
              timezone: props.site.siteAddressDto.geolocatedSiteAddress.timeZone,
            }),
          )
        }}
      </p>
    </Message>
  </template>
</template>
